import sizes from "@frog/source/data/sizes.js"

const MAX_LAYER = 100
const layers = {
    "block": 1,
    "range": 2,
    "escapezone": 3,
    "dangerzone": 4,
    "shadow": 4,
    "building-sides": 4,
    "action-arrow": 5,
    "edge-block-north": 8,
    "edge-block-west": 9,
    "slim-arrow": 9,
    "cursor": 9,
    "healthbar": 9,
    "unit": 10,
    "elemental-icon": 11,
    "ant-arrow": 12,
    "line-ant-arrow": 15,
    "particle": 15,
    "edge-block-south": 16,
    "edge-block-east": 16,
    "debug": 99,
}

export default function pixel(layerKey, position) {
    if(sizes.camera.type == "isometric") {
        return {
            "x": (position.x - position.y) * (sizes.grid.width / 2),
            "y": ((position.x + position.y) * (sizes.grid.height / 2)) - (position.z * sizes.grid.depth),
            // "stack": Math.round(position.x) + Math.round(position.y) (((layers[layerKey] || 0) / MAX_LAYER) * 1),
            "stack": Math.round(position.x) + Math.round(position.y) + Math.ceil(position.z) + (((layers[layerKey] || 0) / MAX_LAYER) * 1),
            // "stack": Math.ceil(position.x) + Math.ceil(position.y) + ((layers[layerKey] || 0) / MAX_LAYER),
            // "stack": position.x + position.y + position.z + (((layers[layerKey] || 0) / MAX_LAYER)),
            // "stack": position.x + position.y + ((layers[layerKey] || 0) / MAX_LAYER),
        }
        // return {
        //     "x":  ((position.x/2) * GRID_WIDTH) - (position.y * GRID_HEIGHT),
        //     "y": ((((position.x/2) * GRID_WIDTH) + (position.y * GRID_HEIGHT)) / 2) - (((position.z || 0) - 1) * GRID_DEPTH),
        //     "z": ((position.z || 0) * 100) + position.x + position.y + (layers[layer] || 0)
        // }
    } else if(sizes.camera.type == "top-down") {
        return {
            "x": position.x * sizes.grid.width,
            "y": position.y * sizes.grid.height
        }
    }
}
